(function ($) {
    $(document).ready(function () {

        // Close the menu when we click on an anchor.
        $('#collapsibleNavbar li a').on('click', function () {
            const navbar = document.getElementById('collapsibleNavbar')
            new bootstrap.Collapse(navbar).hide();
        });
        
    });
})(jQuery);

